<template>
  <div>
    <div class="d-flex align-center justify-space-between" v-if="0">
      <div class="d-flex">
        <botao-padrao
          class="mt-3 mb-3"
          @click="adicionaCriterioAprovacao"
        >
          Novo Critério
        </botao-padrao>
      </div>
    </div>
    <v-data-table
      :key="keyAtualiza"
      :headers="tabela.colunas"
      :items="criterios"
      item-key="sequencia"
      show-expand
      dense
      hide-default-footer
      :no-data-text="$t('modulos.participantes.criterios_aprovacao.sem_dados')"
    >
      <template v-slot:item.sequencia>
        <div class="d-flex">
          <div>
            <dropdown-padrao
              v-if="0"
              text
              color="secondary"
              style="width: 100% !important"
            >
              <template #botao>
                <v-icon> $dotsVertical </v-icon>
              </template>

              <v-list-item-group style="overflow-y: auto">
                <v-list-item
                  class="d-flex min-height-drop-item"
                >
                  <v-icon>$mdiTrashCanOutline</v-icon>
                  {{ $t('geral.botoes.excluir') }}
                </v-list-item>
              </v-list-item-group>
            </dropdown-padrao>
          </div>
        </div>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td
          :colspan="headers.length"
          style="padding: 0"
        >
          <table width="100%">
            <thead>
              <th
                class="th-simple-table"
                height="50"
                width="100"
              >
                Seq.
              </th>
              <th
                class="th-simple-table"
                width="100"
              >
                Operador Lógico
              </th>
              <th class="th-simple-table">
                Tipo de critério
              </th>
              <th
                class="th-simple-table"
                width="300"
              >
                Operador Rel.
              </th>
              <th
                class="th-simple-table"
                width="300"
              >
                Valor
              </th>
            </thead>
            <LinhaCriterio
              v-for="(criterio, index) in item"
              :key="index"
              :item="item"
              :criterio="criterio"
              :opcoes="opcoes"
              @remover="removerCriterio(item.sequencia, index)"
            />
          </table>
          <div
            class="col-12 bg-grey"
          >
            <button @click="adicionaCriterioItem(item.numeroItem)">
              <v-icon> $plus </v-icon>
              {{ $t('modulos.orcamentos.formulario.adicionar') }}
            </button>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EnumeradorService from '@common/services/cadastros/EnumeradorService';
import LinhaCriterio from '../LinhaCriterio.vue';

export default {
  components: {
    LinhaCriterio
  },
  props: {
  },
  data() {
    return {
      items: [],
      opcoes: {
        operadorLogico: [],
        tiposCriterio: [],
        operadorRelacional: [],
        tipoValor: [],
        valorLogico: [],
      },
      keyAtualiza: 1,
      keyAtualizaCriterio: 1,
      expanded: [],
      singleExpand: true,
      tabela: {
        selecionados: [],
        dados: [],
        colunas: [
          {
            value: 'sequencia',
            text: this.$t('modulos.participantes.criterio_aprovacao'),
            sortable: true,
          },
        ],
      },
    };
  },
  computed:{
    criterios() {
      return [this.$store.getters['criterios/getCriterios']]
    }
  },
  mounted() {
    this.buscaOperadorLogico();
    this.opcoes.valorLogico.push(
      {
        text: 'Sim',
        value: true,
      },
      {
        text: 'Não',
        value: false,
      }
    );
  },
  methods: {
    excluir() {},
    adicionaCriterioItem() {
      let criterios = this.$store.getters['criterios/getCriterios']

      this.$store.dispatch('criterios/addCriterio', {newCriterio: {
            numeroItem: criterios.length+1,
            sequencia: criterios.length+1,
            operadorLogico: null,
            tipoCriterio: null,
            operadorRelacional: null,
            tipoValor: null,
            tipoValorLogico: true,
            tipoValorNumerico: true,
            tipoValorPercentual: true,
            valorNumerico: null,
            valorPercentual: null,
            valorLogico: null,
          }});
    },
    removerCriterio(sequencia, index) {
      const criterio = this.criterios.find(
        (item) => item.sequencia === sequencia
      );
      if (criterio) {
        criterio.splice(index, 1);
      }
    },
    adicionaCriterioAprovacao() {
      if(this.criterios.length) {
        this.criterios.push({
          numeroItem: this.criterios.length + 1,
          sequencia: this.criterios.length + 1,
          criterios: [],
        });
        this.expanded.push({
          numeroItem: this.criterios.length,
          sequencia: this.criterios.length,
          criterios: [],
        });

        this.keyAtualiza++;
      }
    },
    buscaOperadorLogico() {
      this.$store.dispatch('Layout/iniciarCarregamento');
      EnumeradorService.buscar('EnumOperadorLogico')
        .then((res) => {
          this.opcoes.operadorLogico = res;
        })
        .finally(() => {
          this.buscaTipoCriterio();
        });
    },
    buscaTipoCriterio() {
      EnumeradorService.buscar('EnumTipoCriterioAprovacaoAutomatica')
        .then((res) => {
          this.opcoes.tiposCriterio = res;
        })
        .finally(() => {
          this.buscaOperadorRelacional();
        });
    },
    buscaOperadorRelacional() {
      EnumeradorService.buscar('EnumOperadorRelacional')
        .then((res) => {
          this.opcoes.operadorRelacional = res;
        })
        .finally(() => {
          this.buscaTipoValor();
        });
    },
    buscaTipoValor() {
      EnumeradorService.buscar('EnumTipoValor')
        .then((res) => {
          this.opcoes.tipoValor = res;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
  },
};
</script>

<style>
.th-simple-table {
  background-color: #d0d5dd;
  height: 15px;
}
.cursor-pointer {
  cursor: pointer;
}
.bg-grey{
    background-color: #d0d5dd
}
</style>
